import { render } from "./PaymentHistory.vue?vue&type=template&id=05093d1b&ts=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__